/*
  Ленивая загрузка видео.

  Видео помечены классом .lazy-video, адрес файла лежит в data-src (для роликов,
  у которых своя версия под телефон и под десктоп — в data-src-mobile / data-src-desktop).
  Файл начинает грузиться только когда видео подходит к экрану. Видео, скрытые
  через CSS, не пересекают экран и потому не грузятся вообще — на этом и держится
  экономия трафика на телефоне.
*/
(function () {
  'use strict';

  var MOBILE = '(max-width: 767px)';
  var LOADED = 'lazyVideoLoaded';

  function pickSource(el) {
    var mobile = el.getAttribute('data-src-mobile');
    var desktop = el.getAttribute('data-src-desktop');
    if (mobile || desktop) {
      var isMobile = window.matchMedia && window.matchMedia(MOBILE).matches;
      return (isMobile && mobile) || desktop || mobile;
    }
    return el.getAttribute('data-src');
  }

  function load(el) {
    if (el.dataset[LOADED]) return;
    var url = pickSource(el);
    if (!url) return;
    el.dataset[LOADED] = '1';

    var source = el.querySelector('source');
    if (!source) {
      source = document.createElement('source');
      source.type = 'video/mp4';
      el.appendChild(source);
    }
    source.src = url;
    el.load();

    var played = el.play();
    if (played && played.catch) played.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('video.lazy-video');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(videos, load);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        load(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '100px 0px' });

    Array.prototype.forEach.call(videos, function (video) { observer.observe(video); });

    watchMenus();
  }

  /*
    Меню и мегаменю скрыты через visibility/opacity, а не display, поэтому
    наблюдатель за экраном их не подхватывает. Ловим открытие руками:
    после клика или наведения в шапке догружаем те видео, что стали видимыми.
  */
  function isShown(el) {
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    if (parseFloat(style.opacity) === 0) return false;
    var parent = el.parentElement;
    while (parent && parent !== document.body) {
      var ps = window.getComputedStyle(parent);
      if (ps.visibility === 'hidden' || ps.display === 'none' || parseFloat(ps.opacity) === 0) return false;
      parent = parent.parentElement;
    }
    return true;
  }

  function loadShownIn(root) {
    var pending = root.querySelectorAll('video.lazy-video');
    Array.prototype.forEach.call(pending, function (video) {
      if (!video.dataset[LOADED] && isShown(video)) load(video);
    });
  }

  function watchMenus() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('header');
    if (!header) return;
    if (!header.querySelector('video.lazy-video')) return;

    /* 350 мс — чуть больше, чем длится анимация раскрытия (0.3s) */
    var recheck = function () { setTimeout(function () { loadShownIn(header); }, 350); };
    header.addEventListener('click', recheck, true);
    header.addEventListener('mouseover', recheck, true);
    header.addEventListener('touchstart', recheck, { capture: true, passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
